export default {"src":"/_next/static/media/icon-0.af24a33a.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};